import { PersonOff } from '@mui/icons-material';
import { Box, Stack, type StackProps, Typography } from '@mui/material';
import { ContactsIntegrationBanner } from '@/components/ContactsIntegration';

type Props = {
  interactionId?: string;
  interactionOwnerId?: string;
  thirdPartyContactsIncluded?: boolean;
  googleAccountLinked?: boolean;
  followUpBossAccountLinked?: boolean;
  compact?: boolean;
} & StackProps;

export const ContactSuggestionsNoResults = ({
  interactionId,
  interactionOwnerId,
  thirdPartyContactsIncluded = true,
  googleAccountLinked,
  followUpBossAccountLinked,
  compact,
  sx,
  ...rest
}: Props) => {
  return (
    <Stack
      direction="column"
      sx={{
        alignItems: 'flex-start',
        gap: 1.5,
        py: 1.5,
        px: 2,
        ...sx,
      }}
      {...rest}
    >
      <ContactsIntegrationBanner
        show={thirdPartyContactsIncluded}
        interactionId={interactionId}
        interactionOwnerId={interactionOwnerId}
        googleAccountLinked={googleAccountLinked}
        followUpBossAccountLinked={followUpBossAccountLinked}
        compact={compact}
      />
      <Stack direction="row" sx={{ alignItems: 'flex-start', gap: 1 }}>
        <PersonOff sx={{ color: 'action.active' }} />
        <Box>
          <Typography sx={{ color: 'text.primary' }}>No Results</Typography>
        </Box>
      </Stack>
    </Stack>
  );
};
